
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DragAndDropModule } from "angular-draggable-droppable";
import { CalendarMonthViewComponent } from "./calendar-month-view.component";
import { CalendarMonthViewHeaderComponent } from "./calendar-month-view-header.component";
import { CalendarMonthCellComponent } from "./calendar-month-cell.component";
import { CalendarOpenDayAppointmentsComponent } from "./calendar-open-day-events.component";
import { CalendarCommonModule } from "../common/calendar-common.module";
import { SharedModule } from "src/app/shared/shared.module";

export {
  CalendarMonthViewComponent, CalendarMonthViewBeforeRenderEvent, CalendarMonthViewAppointmentTimesChangedEvent
} from "./calendar-month-view.component";
export { MonthViewDay as CalendarMonthViewDay } from "calendar-utils";
export { collapseAnimation } from "./calendar-open-day-events.component";

@NgModule({
  imports: [SharedModule, CommonModule, DragAndDropModule, CalendarCommonModule],
  declarations: [
    CalendarMonthViewComponent,
    CalendarMonthCellComponent,
    CalendarOpenDayAppointmentsComponent,
    CalendarMonthViewHeaderComponent
  ],
  exports: [
    DragAndDropModule,
    CalendarMonthViewComponent,
    CalendarMonthCellComponent,
    CalendarOpenDayAppointmentsComponent,
    CalendarMonthViewHeaderComponent
  ]
})
export class CalendarMonthModule { }
